<template>
  <div>404 iso shrug</div>
</template>

<script>
export default {
  name: 'NotFound',
  data: () => {
    return {};
  },
  props: {}
};
</script>

<style scoped></style>
